// underList.ts
import { defineStore } from 'pinia';

interface UnderListEntry {
    value: string | number; // 适当替换成实际的类型
    label: string; // 适当替换成实际的类型
    children?: UnderListEntry[]
}

interface DataStoreState {
    underList: UnderListEntry[]; // 使用具体的类型定义
    districtCnData: any[]; // 适当替换成实际的类型
    orgListData: any[]; // 适当替换成实际的类型
    TargetRegionData: any[];
    countryList: any[];
}

export const useDataStore = defineStore({
    id: 'dataStore',
    state: (): DataStoreState => ({
        underList: [],
        districtCnData: [],
        orgListData: [],
        TargetRegionData: [],
        countryList: [],
    }),
    actions: {
        setUnderList(newUnderList: UnderListEntry[]) {
            this.underList = newUnderList || [];
        },
        setDistrictCnData(newDistrictCnData: any[]) {
            this.districtCnData = newDistrictCnData;
        },
        setOrgListData(newOrgListData: any[]) {
            this.orgListData = newOrgListData;
        },
        setTargetRegionData(newTargetRegionData: any[]) {
            this.TargetRegionData = newTargetRegionData;
        },
        setCountryList(newCountryList: any[]) {
            this.countryList = newCountryList;
        }
    },
    getters: {
        getUnderList(): UnderListEntry[] {
            return this.underList;
        },
        getDistrictCnData(): any[] {
            return this.districtCnData;
        },
        getOrgListData(): any[] {
            return this.orgListData;
        },
        getTargetRegionData(): any[] {
            return this.TargetRegionData;
        },
        getCountryList(): any[] {
            return this.countryList;
        }
    },
});
